/* src/app/modules/spare-parts/widgets-service-parts/widgets-service-parts.component.scss */
.widgets-container {
  display: flex;
  gap: 1rem;
}
.body-card {
  display: flex;
  height: 100%;
  align-items: center;
  max-width: 100%;
  justify-content: space-between;
  padding: 0 0.3rem;
}
.body-card sh-text {
  width: fit-content;
}
.card-label {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.card-value {
  font-size: 28px;
}
/*# sourceMappingURL=widgets-service-parts.component.css.map */
